import { render } from "./materialize_tag.vue?vue&type=template&id=1f05c390&scoped=true"
import script from "./materialize_tag.vue?vue&type=script&lang=ts"
export * from "./materialize_tag.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1f05c390"

export default script